import { IDeadlineSettings } from 'legacy/lut/services/partner360/configuration/models'

interface IDeadlineSettingsParsed {
  Color: string
  EndDate: string
  Market: string
  ProgramType: string
  StartDate: string
}

export const getFormedDeadlineSettings = (data: string | null): Partial<IDeadlineSettings> => {
  if (data) {
    const parsed: IDeadlineSettingsParsed[] = JSON.parse(data)
    return parsed.reduce((acc, cur) => {
      return {
        ...acc,
        [cur.ProgramType]: {
          color: cur.Color,
          endDate: cur.EndDate,
          market: cur.Market,
          startDate: cur.StartDate,
        },
      }
    }, {} as IDeadlineSettings)
  }
  return {}
}
